"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MethodConfig_1 = __importDefault(require("../interface/MethodConfig"));
const config_1 = __importDefault(require("../config"));
class TokenList {
    constructor() {
        this.requireLevel = config_1.default.REQUIRE_LEVEL.ANYONE;
        this.id = 'tokenList';
        this.entryPointID = '';
    }
    getMethodProps() {
        return [new MethodConfig_1.default('util.syncTokens', [], '')];
    }
    proccessCallResponse(responses, isValidAddress, network, currency) {
        return network.tokens.map(token => Object.assign({}, token, {
            price: currency.getToken(token.id).price.toStr(),
            decimals: currency.getToken(token.id).decimals.toNum()
        }));
    }
}
exports.default = TokenList;
;
//# sourceMappingURL=TokenList.js.map